module.exports = __webpack_public_path__ + "img/logo_NRCT 1.6fa96936.png";